// General import
import React, { useState, useRef } from 'react'
import { Button, Toast, Popover, Form,ButtonGroup,Pagination,Carousel,Alert,Nav,Row} from 'react-bootstrap'
import parse from 'html-react-parser'
import { Card,Col} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {loginOut} from './components/Login/LoginFunctions'


// Import from local files
import { SuiteSankeyNode,SuiteSankeyLink,SuiteSankeyData,SuiteSankeyLinkValue } from './types'
import i18next from './traduction'
import {SankeySuiteDialogSaveJSON} from './SankeySuiteDialogSaveJSON'


// Import From AFM
import SupplyUseModelisationProd from 'afmsankey/dist/SankeyReconciliation'
import {afm_menu_configuration_import_export,SplitVerticalModal,processTrade,additional_selector,afm_edition_menu} from 'afmsankey/dist/AFMSankeyMenu'
import {FreeVariables} from 'afmsankey/dist/FreeVariables'


// Import from opensankey
import Menu, { OpenSankeyMenus,OpenSankeyModalWelcome,context_menu_node,context_menu_link,context_zdd,menu_draggable } from 'open-sankey/dist/SankeyMenu'
import { SankeySettingsEditionElementTags } from 'open-sankey/dist/SankeyMenuConfigurationTags'
import * as OpenSankeyUtils from 'open-sankey/dist/SankeyUtils'
import {OpenSankeyConfigurationsMenus} from 'open-sankey/dist/SankeyMenuConfiguration'
import { OpenSankeyMenuConfigurationLayout } from 'open-sankey/dist/SankeyMenuConfigurationLayout'
import {OpenSankeyConfigurationNodesAttributes} from 'open-sankey/dist/SankeyMenuConfigurationNodesAttributes'
import {OpenSankeyMenuConfigurationNodes} from 'open-sankey/dist/SankeyMenuConfigurationNodes'

import {SankeyMenuConfigurationNodesLabel} from 'open-sankey/dist/SankeyMenuConfigurationNodesLabel'
import {SankeyMenuConfigurationNodesIO} from 'open-sankey/dist/SankeyMenuConfigurationNodesIO'

import {OpenSankeyMenuConfigurationLinks} from 'open-sankey/dist/SankeyMenuConfigurationLinks'
import {SankeyMenuConfigurationLinksData} from 'open-sankey/dist/SankeyMenuConfigurationLinksData'
import {SankeyMenuConfigurationLinksAppearence} from 'open-sankey/dist/SankeyMenuConfigurationLinksAppearence'
import {SankeyMenuConfigurationLinksLabel} from 'open-sankey/dist/SankeyMenuConfigurationLinksLabel'

import {toolbar_builder,addAllDropDownNode,addSimpleLevelDropDown,setDiagram} from 'open-sankey/dist/SankeyMenuBanner'
import ModalPreference,{OpenSankeyDefaultModalePreferenceContent,preferenceCheck} from 'open-sankey/dist/SankeyMenuPreferences'
import { keyHandler } from 'open-sankey/dist/SankeyDraw'

import {updateLayout} from 'open-sankey/dist/SankeyLayout'


// Import Form SankeyPlus
import * as SankeyViews from 'sankeyanimation/dist/SankeyPlusViews'
import { SankeyPlusNodesAttributes,SankeyPlusNodeIcon,context_node_icon } from 'sankeyanimation/dist/SankeyPlusNodes'
import {SankeyPlusModalStyleLink,SankeyPlusModalStyleNode} from 'open-sankey/dist/SankeyStyle'
import {SankeyPlusMenuConfigurationFreeLabels,SankeyPlusMenuPreferenceLabels} from 'sankeyanimation/dist/SankeyPlusMenuConfigurationLabels'
import * as SankeyPlusGradient from 'sankeyanimation/dist/SankeyPlusGradient'
import {SankeyPlusShortcut} from 'sankeyanimation/dist/SankeyPlusItemShortcut'
import { SankeyPlusLabel } from 'sankeyanimation/src/types'
import { SankeyPlusNodeFO} from 'sankeyanimation/dist/SankeyPlusForeignObject'
import { plus_sankey_layout } from 'sankeyanimation/dist/SankeyPlusConvert'


// Import From sankeyDev
import {PublishModal,SankeyDevMenuPublishItem} from 'sankeydev/dist/PublishModale'
import {MenuConfigHideLoneNode} from 'sankeydev/dist/HideLoneNodeFunction'
import {itemDemo} from 'sankeydev/dist/MenuExampleDemo'
import {SankeyDevMenuDataPercent} from 'sankeydev/dist/PercentValue'
import {MenuEnregistrerExcelSimple} from 'sankeydev/dist/MenuEnregistrerExcelSimple'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareNodes, faArrowPointer,faFilter,faFolderTree, faDiagramProject,faArrowsLeftRight,faArrowsUpDown } from '@fortawesome/free-solid-svg-icons'
import { FaAngleDoubleLeft,FaUser,FaHome,FaCaretSquareRight,FaCaretSquareLeft,FaPowerOff} from 'react-icons/fa'

declare const window: Window &
typeof globalThis & {
  SankeyToolsStatic: boolean
  sankey: {
    sankey_data_file:RequestInfo
    sous_filieres : { [ key : string ] : string }
    units: string[]
    flask_logo? : string
    flask_header? : string
    logo_width? : number
    legend_average : string
    legend_uncert : string
    help_text : string
    welcome_text: string
    excel : string
    logo: string,
    advanced: boolean,
    intro: string
  }
}

type SankeyMenuTypes = {
    data: SuiteSankeyData,
    set_data: (d:SuiteSankeyData)=>void,
    get_default_data:()=>SuiteSankeyData,
    displayed_input_link_value: string,
    set_displayed_input_link_value: (s:string)=>void,
    set_animating: (b:boolean)=>void,
    multi_selected_nodes: {current : SuiteSankeyNode[]}
    multi_selected_links: {current : SuiteSankeyLink[]}
    multi_selected_label: {current : SankeyPlusLabel[]}
    selected_node: {current : SuiteSankeyNode},
    // selected_link: {current : SuiteSankeyLink},
    button_ref: {current : HTMLLabelElement| null},
    accordion_ref: {current : HTMLDivElement| null},
    links_accordion_ref: {current : HTMLDivElement| null},
    nodes_accordion_ref: {current : HTMLDivElement| null},
    exemple_menu        : object,
    formations_menu      : object,
    logo: string,
    logo_terriflux: string,
    token: boolean,
    has_sankey_suite: boolean,
    has_open_sankey_plus: boolean,
    has_sankeydev:boolean,
    unsetTokens: ()=>void,
    useNavigate:()=>any,
    mode_selection: {current:string},
    user_scale:number,
    set_user_scale:(n:number)=>void,
    SuiteGetLinkValue:(data: SuiteSankeyData, idLink: string, up?: boolean) => SuiteSankeyLinkValue,
    tags_selected: {[k: string]: string},
    set_tags_selected: (o:{[k: string]: string})=>void,
    master_data:SuiteSankeyData | undefined,
    set_master_data:(d:SuiteSankeyData)=>void,
    reinitialization:()=>void,
    selected_style_node:string,
    set_selected_style_node:(s:string)=>void,
    selected_style_link:string,
    set_selected_style_link:(s:string)=>void,
    view:string,
    set_view:(s:string)=>void,
    first_selected_node:object,
    set_first_selected_node:(o:object)=>void,
    show_toast_limit_node:boolean,
    set_show_toast_limit_node:(b:boolean)=>void,
    size_of_draw_zone:(d:SuiteSankeyData)=>number[],
    name_user:string,
    display_link_opacity:string,
    set_display_link_opacity:(s:string)=>void,
    legend_position:number[],
    set_legend_position:(n:number[])=>void,
    logo_OS:string,
    logo_OSP:string,
    logo_OSS:string,
    contextualised_node:SuiteSankeyNode|undefined,
    set_contextualised_node:(n:SuiteSankeyNode|undefined)=>void,
    contextualised_link:SuiteSankeyLink|undefined,
    set_contextualised_link:(n:SuiteSankeyLink|undefined)=>void,
    set_agregation_node:(b:string)=>void,
    set_is_agregation:(b:boolean)=>void,
    set_show_agregation:(b:boolean)=>void,
    pointer_pos:{current:number[]},
    show_context_zdd:boolean,
    set_show_context_zdd:(b:boolean)=>void,
    suite_convert_data:(d:SuiteSankeyData)=>void,
    show_nav:boolean,set_show_nav:(b:boolean)=>void,
    show_menu_node_apparence:boolean,set_show_menu_node_apparence:(b:boolean)=>void,
    show_menu_node_label:boolean,set_show_menu_node_label:(b:boolean)=>void,
    show_menu_node_io:boolean,set_show_menu_node_io:(b:boolean)=>void,
    show_menu_link_data:boolean,set_show_menu_link_data:(b:boolean)=>void,
    show_menu_link_appearence:boolean,set_show_menu_link_appearence:(b:boolean)=>void,
    show_menu_link_label:boolean,set_show_menu_link_label:(b:boolean)=>void,
    show_menu_layout:boolean,set_show_menu_layout:(b:boolean)=>void,
    show_menu_node_icon:boolean,set_show_menu_node_icon:(b:boolean)=>void,
    show_apply_layout:boolean,set_show_apply_layout:(b:boolean)=>void,
    closeAllMenu:()=>void,
    maximum_flux:number|null|undefined,
    set_maximum_flux:(n:number)=>void,

}

const SuiteUpdateLayout=( data: SuiteSankeyData,new_layout: SuiteSankeyData,mode:string[])=>{
    updateLayout(data,new_layout,mode)
    plus_sankey_layout(data,new_layout)
}

export const SankeySuiteMenu = ({
  data,
  set_data,
  get_default_data,
  displayed_input_link_value,
  set_displayed_input_link_value,
  set_animating,
  multi_selected_nodes,
  multi_selected_links,
  multi_selected_label,
  selected_node,
//   selected_link,
  button_ref,
  accordion_ref,
  links_accordion_ref,
  nodes_accordion_ref,
  exemple_menu,
  formations_menu,
  logo,
  logo_terriflux,
  token,
  has_sankey_suite,
  has_open_sankey_plus,
  has_sankeydev,
  unsetTokens,
  useNavigate,
  mode_selection,
  user_scale,
  set_user_scale,
  SuiteGetLinkValue,
  tags_selected,
  set_tags_selected,
  master_data,
  set_master_data,
  reinitialization,
  selected_style_node,
  set_selected_style_node,
  selected_style_link,
  set_selected_style_link,
  view,
  set_view,
  first_selected_node,
  set_first_selected_node,
  show_toast_limit_node,
  set_show_toast_limit_node,
  size_of_draw_zone,
  name_user,
  display_link_opacity,
  set_display_link_opacity,
  legend_position,
  set_legend_position,
  logo_OS,
  logo_OSP,
  logo_OSS,
  contextualised_node,
  set_contextualised_node,
  contextualised_link,
  set_contextualised_link,
  set_agregation_node,
  set_is_agregation,
  set_show_agregation,
  pointer_pos,
  show_context_zdd,
  set_show_context_zdd,
  suite_convert_data,
  show_nav,set_show_nav,
  show_menu_node_apparence,
  set_show_menu_node_apparence,
  show_menu_node_label,
  set_show_menu_node_label,
  show_menu_node_io,
  set_show_menu_node_io,
  show_menu_link_data,
  set_show_menu_link_data,
  show_menu_link_appearence,
  set_show_menu_link_appearence,
  show_menu_link_label,
  set_show_menu_link_label,
  show_menu_layout,
  set_show_menu_layout,
  show_menu_node_icon,
  set_show_menu_node_icon,
  show_apply_layout,
  set_show_apply_layout,
  closeAllMenu,
  maximum_flux,
  set_maximum_flux

} : SankeyMenuTypes) => {

    const [nav_item_active, set_nav_item_active] = useState<string>('')
    const [style_to_apply, set_style_to_apply] = useState('default')
    const [show_modal_welcome,set_show_modal_welcome]=useState(true)
    const [never_see_again,set_never_see_again]=useState((localStorage.getItem('dontSeeAggainWelcome')==='1'))

    // For OpenSankeyConfigurationsMenus
    const [sub_nav_item_active, set_sub_nav_item_active] = useState<string>('')


    // For OpenSankeyMenuConfigurationLayout
    const [minimum_flux, set_minimum_flux] = useState(data.minimum_flux)
    const [node_hspace, set_node_hspace] = useState(data.h_space)
    const [node_vspace, set_node_vspace] = useState(data.v_space)

    // For OpenSankeyMenuConfigurationNodes
    const [link_io,set_link_io]=useState<string>('output')
    const [link_pos,set_link_pos]=useState<string>('right')
    const [tab_colored,set_tab_colored]=useState<boolean>(false)

    // For SankeyPlusMenuConfigurationFreeLabels
    const [forceUpdate, setForceUpdate] = useState(false)

    // For afm_menu_configuration_import_export
    const [trade_close,set_trade_close] = useState(true)

    const [show_load,set_show_load] = useState(false)

    //- Processess
    const [processing,setProcessing] = useState(false)
    const [failure,setFailure] = useState(false)
    const [not_started,setNotStarted] = useState(true)
    const [result,setResult] = useState('')
    const [path,setPath] = useState('')

    //- AFMSankey
    const [show_split_trade_dialog,set_show_split_trade_dialog] = useState(false)
    const action_type = useRef('optim_sankey')
    const [show_reconciliation,set_show_reconciliation] = useState(false)

    //- OpenSankey+
    const [show_toast_new_view, set_show_toast_new_view] = useState(false)
    const [show_toast_update_view, set_show_toast_update_view] = useState(false)
    const [view_not_saved,set_view_not_saved]=useState('')

    // Modals
    const [show_excel_dialog, set_show_excel_dialog] = useState(false)
    const [show_save_json, set_show_save_json] = useState(false)
    const [showPreference, setShowPreference] = useState(false)

    const [radio_selected] = useState<string>('local')
    const [showStyle, setShowStyle] = useState(false)

    //- Modals and Dialogs
    // const [welcome_text,set_welcome_text] = useState(window.sankey ? window.sankey.welcome_text : '')

    // For OpenSankeyMenuConfigurationLinks
    const [tags_group_key, set_tags_group_key] = useState(Object.keys(data.fluxTags).length > 0 ? Object.keys(data.fluxTags)[0] : '')

    // Modal et fonctions pour l'edition et affectation des style de flux
    const [showStyleLink, setShowStyleLink] = useState(false)
    const showStyleEditionLink = () => {
      setShowStyleLink(true)
    }
    const [show_publish_dialog,set_show_publish_dialog] = useState(false)
    const [show_modalTemplate, set_show_modalTemplate] = useState(false)

    const [show_modale_tuto,set_show_modale_tuto]=useState(false)
    const [show_modale_support,set_show_modale_support]=useState(false)


    // Modal et fonctions pour l'édition et affectation des styles de noeud

    const showStyleEdition = () => {
        setShowStyle(true)
    }

    let url_prefix='/opensankey/'
    if (has_sankey_suite) {
        url_prefix='/sankeytools/'
    }
    // Create traduction function
    const {t} = useTranslation()

    const launch = (path:string) => {
        setPath(path)
        set_show_load(true)
        setProcessing(true)
        setFailure(true)
        setNotStarted(false)
        setResult('')
    }

    const tmp=JSON.parse(JSON.stringify(exemple_menu))
    let list_template_data=[] as string[]
    // Si exemple_menu contient OpenSankey et que ce sous dossier contient les templates simple alors remple la liste des templates avec les modèle simples
    if(Object.keys(tmp).length!==0 && Object.keys(tmp).includes('OpenSankey') && Object.keys(tmp['OpenSankey']).includes('easy_template') ){
        list_template_data=tmp['OpenSankey']['easy_template'].filter((f:string)=>!f.includes('.xlsx'))
    // Si l'un des sous dossier d'OpenSankey dans exemple_menu est expert_template alors ajoute les modèles expert à la liste des modèles
        if( token && Object.keys(tmp['OpenSankey']).includes('expert_template') ){
        list_template_data.push(tmp['OpenSankey']['expert_template'])
        list_template_data=list_template_data.flat()
        }
    }

    const cardsTemplate=
    <>
        {list_template_data.map((_,idx) => {
            const title=_.split('.').splice(0,1).join('')
            return(
                <Col key={idx}>
                <Card>
                    <Card.Img className='img-card' variant="top" src={'/fm/userfiles/OpenSankey/image_preview/'+title+'.png'} style={{'objectFit':'contain','minHeight':'350px','maxHeight':'500px'}} />
                    <Card.Body>
                    <Card.Title>{title.replaceAll('_',' ')}</Card.Title>
                    <Card.Text>

                    </Card.Text>
                    <ButtonGroup>
                        <Button variant='primary'
                        onClick={() => {
                            multi_selected_nodes.current = []
                            multi_selected_links.current = []
                            multi_selected_label.current = []
                            const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                            OpenSankeyUtils.uploadExemple(
                            'OpenSankey/'+difficulty_file+'/'+list_template_data[idx], url_prefix, data, set_data,reinitialization,suite_convert_data
                            )
                            set_data({...data})
                        }}>{t('useTemplate')}</Button>

                        <Button variant='info'
                        onClick={() => {
                            multi_selected_nodes.current = []
                            multi_selected_links.current = []
                            multi_selected_label.current = []
                            const difficulty_file=(tmp['OpenSankey']['easy_template'].includes(list_template_data[idx]))?'easy_template':'expert_template'
                            OpenSankeyUtils.downloadExempleExcel(
                            'OpenSankey/'+difficulty_file+'/'+list_template_data[idx]
                            )
                        }}>{t('dl')}</Button>
                    </ButtonGroup>
                    </Card.Body>
                </Card>
                </Col>
            )}
        )}
    </>

    const additional_shortcut_item=[] as JSX.Element[]
    additional_shortcut_item.push(SankeyPlusShortcut(t))
    let carousel_img=[] as string[]
    if(tmp['OpenSankey'] && tmp['OpenSankey']['carousel_img']){
        carousel_img=tmp['OpenSankey']['carousel_img']
    }
    const content_carousel=<Carousel variant='dark'> {
        carousel_img.map((_) => {
            const title=_.split('.').splice(0,1).join('')
            return (<Carousel.Item>
                <img alt={title} src={'/fm/userfiles/OpenSankey/image_carousel/'+_}   style={{'objectFit':'contain','width':'100%','height':'650px',display:'inline-block'}}   />
            </Carousel.Item>)
        })
    }</Carousel>

    const style_border='solid 1px grey'
    const [active_page,set_active_page]=useState((window.sankey && window.sankey.welcome_text)?'read_me':'intro')
    let src_intro_static = 'intro_static.png'
    const node_filter = Object.entries(data.nodeTags).filter(([, v]) => v.banner !== 'none' ).length > 0
    const flux_filter = Object.entries(data.fluxTags).filter(([, v]) => v.banner !== 'none').length > 0
    const buttons_filter=<>{(node_filter)?<Button size='sm' variant='light'>{t('Menu.Noeuds')}</Button>:<></>}
        {(flux_filter)?<Button size='sm' variant='light' >{t('Menu.flux')}</Button>:<></>}
        {(Object.values(data.dataTags).length>0)?<Button size='sm' variant='light'>{t('Banner.data')}</Button>:<></>}</>

    // Content for welcome modal : Introduction
    const pagination_intro = <Pagination.Item active={active_page==='intro'} key={'intro'} onClick={()=>{
        set_active_page('intro')
        }}>
            {t('welcome.intro')}
    </Pagination.Item>

    const intro = <div>
        {window.SankeyToolsStatic ?<img src={src_intro_static} alt='intro carousel' style={{'objectFit':'contain','width':'100%'}}/>:content_carousel}
        <p>{t('Banner.hlp_1_txt_1')}</p>
        <table style={{'border':style_border,textAlign:'center'}}>
            {!window.SankeyToolsStatic?
                <>
                    <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'danger'}><FaUser/></Button></td><td style={{'border':style_border}}>{t('welcome.9')}</td></tr>
                    <tr style={{'border':style_border}}><td style={{'border':style_border}}><ButtonGroup><Button size='sm' variant={'info'}><FontAwesomeIcon icon={faArrowPointer} /></Button><Button size='sm' variant={'secondary'}><FontAwesomeIcon icon={faShareNodes} /></Button></ButtonGroup></td><td style={{'border':style_border}}>{t('welcome.1')}</td></tr>
                </>:
                <></>
            }

            <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'warning'}><FontAwesomeIcon icon={faFolderTree} /></Button></td><td style={{'border':style_border}}>{t('welcome.3')}</td></tr>
            <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'danger'}><FontAwesomeIcon icon={faFilter} /></Button></td><td style={{'border':style_border}}>{t('welcome.4')}</td></tr>
            <tr style={{'border':style_border}}><td style={{'border':style_border}}><ButtonGroup><Button size='sm' variant={'dark'}><FontAwesomeIcon icon={faArrowsUpDown} /></Button><Button size='sm' variant={'dark'}><FontAwesomeIcon icon={faArrowsLeftRight} /></Button></ButtonGroup></td><td style={{'border':style_border}}>{t('welcome.5')}</td></tr>
            <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'success'}><FontAwesomeIcon icon={faDiagramProject} /></Button></td><td style={{'border':style_border}}>{t('welcome.6')}</td></tr>
            <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'info'}> ?</Button></td><td style={{'border':style_border}}>{t('welcome.7')}</td></tr>
            <tr style={{'border':style_border}}><td style={{'border':style_border}}><Button size='sm' variant={'success'}><FaAngleDoubleLeft/></Button></td><td style={{'border':style_border}}>{t('welcome.10')}</td></tr>
            {(!window.SankeyToolsStatic || (window.SankeyToolsStatic && data.view.length!==0))?
                <tr style={{'border':style_border}}>
                    <td style={{'border':style_border}}>
                        <ButtonGroup>
                            <Button size='sm' variant={'light'}><FaHome/></Button>
                            <Button size='sm' variant={'light'}><FaCaretSquareLeft/></Button>
                            <Button size='sm' variant={'light'}><FaCaretSquareRight/></Button>
                        </ButtonGroup>
                    </td>
                    <td>{t('welcome.view')}</td>
                </tr>:
                <></>
            }
            {window.SankeyToolsStatic && window.sankey && window.sankey.excel?
                <tr style={{'border':style_border}}>
                    <td style={{'border':style_border}}>
                        <Button variant='link'>{t('Banner.tl')}</Button>
                    </td>
                    <td style={{'border':style_border}}>{t('welcome.excel')}</td>
                </tr>:
                <></>
            }
            <tr style={{'border':style_border}}>
                <td style={{'border':style_border}}>{buttons_filter}</td>
                <td style={{'border':style_border}}>{t('welcome.2')}</td>
            </tr>
        </table>
    </div>

    // Content for welcome modal : Licences explanation
    const content_licence = <>
        {/* OpenSankey */}
        <Row>
            <Col xs={3}>
                <img src={logo_OS} alt='logo_OS' style={{'objectFit':'contain','width':'250px'}}/>
            </Col>
            <Col style={{whiteSpace:'pre-line'}}>
                {t('Menu.presentation_OS')}
                <Button>{t('desire_to_know_more')}</Button>
            </Col>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        {/* OpenSankey+ */}
        <Row>
            <Col style={{whiteSpace:'pre-line'}}>{t('Menu.presentation_OSP')}
                <Button href="https://terriflux.com/downloads/open-sankey-plus/" target="_blank" rel="noopener noreferrer">
                    {t('desire_to_know_more')}
                </Button>
            </Col>
            <Col xs={3}><img src={logo_OSP} alt='logo_OSP' style={{'objectFit':'contain','width':'250px'}}/></Col>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        {/* SankeySuite */}
        <Row>
            <Col xs={3}><img src={logo_OSS} alt='logo_OSS' style={{'objectFit':'contain','width':'250px'}}/></Col>
            <Col style={{whiteSpace:'pre-line'}}>
                {t('Menu.presentation_OSS')}
                <Button href="https://terriflux.com/downloads/sankey-suite/" target="_blank" rel="noopener noreferrer">
                    {t('desire_to_know_more')}
                </Button>
            </Col>
        </Row>
    </>

    // Content for welcome modal : Updates in Sankey app
    let image1 = require('./css/news_material/' + t('welcome.news_content.230803.image1'))
    let image2 = require('./css/news_material/' + t('welcome.news_content.230803.image2'))
    let image3 = require('./css/news_material/' + t('welcome.news_content.230803.image3'))
    let image4 = require('./css/news_material/' + t('welcome.news_content.230803.image4'))
    if ( !window.location.href.includes('localhost') ) {
        image1 = image1.replace('static/', 'static/sankeysuite/')
        image2 = image2.replace('static/', 'static/sankeysuite/')
        image3 = image3.replace('static/', 'static/sankeysuite/')
        image4 = image4.replace('static/', 'static/sankeysuite/')
    }
    const content_news=<>
        <Row>
            <h2>{t('welcome.news_content.230803.main_title')}</h2>
            <p><b>{t('welcome.news_content.230803.main_content')}</b></p>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        <Row>
            <h3>{t('welcome.news_content.230803.sub_title_1')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_1')}</p>
            <Col xs={3}><img src={image1} alt='Right clic nodes' style={{'objectFit':'contain','height':'250px'}}/></Col>
            <Col xs={3}><img src={image2} alt='Right clic links' style={{'objectFit':'contain','height':'250px'}}/></Col>
            <Col xs={6}><img src={image3} alt='Right clic background' style={{'objectFit':'contain','height':'250px'}}/></Col>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        <Row>
            <h3>{t('welcome.news_content.230803.sub_title_2')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_2')}</p>
            <Col xs={3}><img src={image4} alt='Selection zone' style={{'objectFit':'contain','height':'250px'}}/></Col>
        </Row>
        <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }}/>
        <Row>
            <h3>{t('welcome.news_content.230803.sub_title_3')}</h3>
            <p>{t('welcome.news_content.230803.sub_content_3')}</p>
        </Row>
    </>

    let pagination_read_me = (window.sankey && window.sankey.welcome_text)?
        <Pagination.Item active={active_page==='read_me'} key={'read_me'} onClick={()=>{
            set_active_page('read_me')}}>{t('welcome.read_me')}
        </Pagination.Item>:
        <></>

    const pagination_rc = window.SankeyToolsStatic?
        <></>:
        <Pagination.Item active={active_page==='licence'} key={'licence'} onClick={()=>{
            set_active_page('licence')
        }}>
            {t('welcome.licence')}
        </Pagination.Item>

    const pagination_news=<Pagination.Item active={active_page==='news'} key={'news'} onClick={()=>{
        set_active_page('news')
        }}>
            {t('welcome.news')}
    </Pagination.Item>

    const external_pagination=[
        pagination_read_me,
        pagination_intro,
        pagination_rc,
        pagination_news]

    const external_content={
        'read_me': window.sankey && window.sankey.welcome_text ?
            parse(window.sankey.welcome_text) :
            '','intro':intro,'rc':<></>,'licence':content_licence,'news':content_news}

    const intro_modal=OpenSankeyModalWelcome(
        t,
        active_page,
        set_active_page,
        show_modal_welcome,
        set_show_modal_welcome,
        never_see_again,
        set_never_see_again,
        additional_shortcut_item,
        external_pagination,
        external_content,
        exemple_menu)


    //- 1. Builds Configuration Menus
    //- 1.1 Builds Configuration Menus Layout
    let  menu_configuration_layout= OpenSankeyMenuConfigurationLayout(t,data,set_data,user_scale,set_user_scale,legend_position,set_legend_position)

    //- 1.2 Builds Configuration Menus Node
    //- 1.2.1 Builds Configuration Menus Node Attributes
    let menu_configuration_nodes_attributes = OpenSankeyConfigurationNodesAttributes(t,data,set_data,multi_selected_nodes,false,selected_style_node)

    menu_configuration_nodes_attributes = menu_configuration_nodes_attributes.concat(SankeyPlusNodesAttributes(t,data,set_data,multi_selected_nodes,has_open_sankey_plus,false,selected_style_node))

    if(has_sankeydev){
        menu_configuration_nodes_attributes = menu_configuration_nodes_attributes.concat(MenuConfigHideLoneNode(t,data,set_data,multi_selected_nodes))
    }

    //- 1.2.2 Builds Configuration Menus Node
    const menu_configuration_nodes = OpenSankeyMenuConfigurationNodes(t,data,set_data,multi_selected_nodes,menu_configuration_nodes_attributes,link_io,set_link_io,link_pos,set_link_pos,tab_colored,set_tab_colored,SuiteGetLinkValue)


    menu_configuration_nodes['icon']=SankeyPlusNodeIcon(t,data,set_data,multi_selected_nodes,radio_selected,has_open_sankey_plus,false)
    menu_configuration_nodes['fo']=SankeyPlusNodeFO(t,data,set_data,multi_selected_nodes,has_open_sankey_plus)
    //- 1.2.3 Builds Configuration Menus Node Tags
    const menu_configuration_nodes_tags=<SankeySettingsEditionElementTags
        t={t}
        data={data}
        set_data={set_data}
        elementTagNameProp='nodeTags'
        elementNameProp='nodes' />

    //- 1.3 Builds Configuration Menus Links
    //- 1.3.1.1 Builds different subpart for Menu Links according to activated token
    const additional_data_element=[]
    const add_link_appearence_item=[] as JSX.Element[]
    if (has_sankey_suite) {
        additional_data_element.push(FreeVariables(data,set_data,multi_selected_links,tags_selected,{}))
    }
    if(has_sankeydev){
        additional_data_element.push(SankeyDevMenuDataPercent(data,set_data,multi_selected_links,tags_selected))
    }
    add_link_appearence_item.push(SankeyPlusGradient.menu_conf_link_apparence_gradient(t,multi_selected_links,data,set_data,has_open_sankey_plus,false,selected_style_link))
    //- 1.3.1.2 Builds the core for Menu Links
    const menu_configuration_links = OpenSankeyMenuConfigurationLinks(data,set_data,multi_selected_links,t,tags_group_key,set_tags_group_key,tags_selected,set_tags_selected,additional_data_element,displayed_input_link_value,set_displayed_input_link_value,add_link_appearence_item,display_link_opacity,set_display_link_opacity)

    //- 1.3.2 Builds Configuration Menus Link tags
    const  menu_configuration_link_tags=<SankeySettingsEditionElementTags
        t={t}
        data={data}
        set_data={set_data}
        elementTagNameProp='fluxTags'
        elementNameProp='links' />

    //- 1.4 Builds Configuration Menus DataTags
    const  menu_configuration_data_tags=<SankeySettingsEditionElementTags
        t={t}
        data={data}
        set_data={set_data}
        elementTagNameProp='dataTags'
        elementNameProp='links' />

    //- 1.5 Builds Configuration Menus FreeLabel
    let menu_configuration_free_labels=<></>

    menu_configuration_free_labels=SankeyPlusMenuConfigurationFreeLabels(data,set_data,multi_selected_label,t,forceUpdate,setForceUpdate,nav_item_active,set_nav_item_active,has_open_sankey_plus)

    //- 1.7 Finish builds Configuration Menus
    let configurations_menus =  OpenSankeyConfigurationsMenus(
        t,
        data, set_data,nav_item_active,set_nav_item_active,
        nodes_accordion_ref,links_accordion_ref,
        selected_node,multi_selected_nodes,multi_selected_links,
        style_to_apply,set_style_to_apply,set_show_nav,
        menu_configuration_layout,menu_configuration_nodes_tags, menu_configuration_link_tags, menu_configuration_data_tags,
        menu_configuration_nodes,menu_configuration_links,menu_configuration_free_labels,sub_nav_item_active,set_sub_nav_item_active,
        has_open_sankey_plus,token,set_displayed_input_link_value,tags_selected,set_tags_selected,set_display_link_opacity
    )
    const _load_json = useRef<HTMLInputElement>(null)
    configurations_menus.splice(4,0,SankeyViews.viewsAccordion(
        data,set_data,nav_item_active,set_nav_item_active,view,set_view,multi_selected_nodes,multi_selected_links,multi_selected_label,master_data,set_master_data,_load_json,t,has_open_sankey_plus,set_view_not_saved
    ))
    //- construct here as hook inside afm_menu_configuration_import_export can not be called inside if.
    if (has_sankey_suite) {
        const the_afm_menu_configuration_import_export = afm_menu_configuration_import_export(data,set_data,nav_item_active,set_nav_item_active,trade_close,set_trade_close)
        configurations_menus.splice(3,0,the_afm_menu_configuration_import_export)
    }
    //- End of 1. Build configuration Menus

    //- 2.  Build Menus
    //- 2.1 Build Menus dropdown
    //- 2.2 Build Menus banner
    //- 2.3 Build Menus toolbar
    let additional_edition_item=[] as JSX.Element[]
    if(has_sankeydev){
        const item_publish=SankeyDevMenuPublishItem(t,set_show_publish_dialog)
        additional_edition_item.push(item_publish)
    }

    let additional_save_item=[] as JSX.Element[]
    if(has_sankeydev){
        const item_save_excel_simple=MenuEnregistrerExcelSimple(url_prefix,data)
        additional_save_item.push(item_save_excel_simple)
    }

    const sankey_menus = OpenSankeyMenus(
        t,setShowPreference,reinitialization,get_default_data,set_show_apply_layout,set_show_excel_dialog,
        set_show_save_json,showStyleEdition,showStyleEditionLink,
        set_show_modal_welcome,set_never_see_again,data,set_data,set_show_modalTemplate,set_show_modale_support,additional_edition_item,additional_save_item,set_tags_selected,suite_convert_data
    )

    if( !window.SankeyToolsStatic){
        sankey_menus['formation']=<></>

    }

    if(has_sankeydev && !window.SankeyToolsStatic){
        sankey_menus['demo']=itemDemo(t,exemple_menu,url_prefix,data,set_data,multi_selected_nodes,multi_selected_links,multi_selected_label,launch,reinitialization,suite_convert_data)
    }
    if (has_sankey_suite && !window.SankeyToolsStatic) {
        sankey_menus['afm']=afm_edition_menu(data,set_show_split_trade_dialog,action_type,set_show_reconciliation)
    }

    // 2.4 Modal linked to menu item
    const external_menu_modal=[] as JSX.Element[]
    const sankey_plus_menu_node_attr_for_style= SankeyPlusNodesAttributes(t,data,set_data,multi_selected_nodes,has_open_sankey_plus,true,selected_style_node)
    const regular_ui=OpenSankeyDefaultModalePreferenceContent(t,data,set_data,i18next)

    const add_style_link_appearence_item=[] as JSX.Element[]
    add_style_link_appearence_item.push(SankeyPlusGradient.menu_conf_link_apparence_gradient(t,{current:[]},data,set_data,has_open_sankey_plus,true,selected_style_link))


    const modale_style_link=<React.Fragment key={'modale_style_link'}>{SankeyPlusModalStyleLink(t,data,set_data,showStyleLink,setShowStyleLink,selected_style_link,set_selected_style_link,add_style_link_appearence_item,display_link_opacity,set_display_link_opacity)}</React.Fragment>
    const modale_style_node=<React.Fragment key={'modale_style_node'}>{SankeyPlusModalStyleNode(t,data,set_data,showStyle,setShowStyle,selected_style_node,set_selected_style_node,[sankey_plus_menu_node_attr_for_style],[])}</React.Fragment>

    // Warning when we try to create node with mouse click and we have exceeded the number for unconnected user
    const toast_warning_limit_node=<Toast key={'limit_node'}  show={show_toast_limit_node} onClose={()=>set_show_toast_limit_node(false)} autohide bg='warning' className='toastWarningLimitNode' style={{ 'position': 'absolute', 'marginTop': '300px', 'marginLeft': '250px', 'zIndex': 1 }}>
        <Toast.Header  closeButton={false}> <small className='me-auto'>Attention</small> </Toast.Header>
        <Toast.Body>Nombre limite de noeud atteint pour les utilisateurs non connecté</Toast.Body>
    </Toast>
    // Add Checkbox in preference menu to display the storytelling menu in menu configuration

    regular_ui['form'].push(SankeyViews.SankeyPlusMenuPreferenceView(data,set_data,preferenceCheck))
    regular_ui['form'].push(SankeyPlusMenuPreferenceLabels(t,data,set_data))

    // if(has_sankeydev){
    //     regular_ui['mode']=SankeyDev_mode_Construction_Visualisation(data,set_data,mode_selection)
    // }
    const elments_of_modale_preference=Object.values(regular_ui).map(d=>{
        return <>{d}<hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 1 }} /></>
    })

    const modale_preference=<React.Fragment key={'modale_preference'}><ModalPreference
        showPreference={showPreference}
        setShowPreference={setShowPreference}
        ui={elments_of_modale_preference}
    /></React.Fragment>

    const modalViewNotSaved=SankeyViews.modal_view_not_saved(view_not_saved,set_view_not_saved,t,master_data,set_master_data,data,set_data,view)

    external_menu_modal.push(modale_style_link)
    external_menu_modal.push(modale_style_node)
    external_menu_modal.push(modale_preference)
    external_menu_modal.push(toast_warning_limit_node)
    external_menu_modal.push(intro_modal)
    external_menu_modal.push(modalViewNotSaved)
    if(has_sankeydev){
        const publishImpl = (file_path:string) =>{
        // const form_data = new FormData()
        // form_data.append('file', input_file)

        const path = window.location.href

        const url = path + '/sankeydev/sankey/publish'

        const new_data = JSON.parse(JSON.stringify((master_data && view!=='none')?master_data:data))
        new_data.file_name = file_path

        const fetchData = {
            method: 'POST',
            body: JSON.stringify(new_data, null, 2)
        }

        fetch(url, fetchData).then( response => {
            if (!response.ok) {
            alert(response)
            }
        })
        set_show_publish_dialog(false)
        }

        const modale_publish=<PublishModal
        key={"publish"}
        t={t}
        show_publish_dialog={show_publish_dialog}
        set_show_publish_dialog={set_show_publish_dialog}
        publishImpl = {publishImpl}
        data = {data} />

        external_menu_modal.push(modale_publish)

    }

    const func_current_filter=(
        new_current_filter: number
    ) => {
        const { display_style } = data
        display_style.filter = +new_current_filter
        set_data({ ...data })
    }

    const opacity_advanced =  !window.SankeyToolsStatic ? '0.3' : '0'
    //Popover element to handle node levels (aggregation)
    let detail_level=
        <Popover id='popover-details-level' style={{maxWidth:'100%'}}>
        <Popover.Header as="h3">{t('Banner.ndd')}</Popover.Header>
        <Popover.Body style={{  marginLeft: '5px', width: '350px' }}>

            <>{(Object.entries(data.levelTags).length > 0) ? (<>
            {addSimpleLevelDropDown(t,data,set_data)}</>
            ) : (<>
            <Form.Control placeholder="Pas de filtrage" style={{ opacity: opacity_advanced, color: '#6c757d' }} disabled /></>)}</>
        </Popover.Body>
        </Popover>
    if(has_open_sankey_plus){
        if ('Primaire' in data.levelTags && data.levelTags['Primaire'].activated === true) {
        Object.values(data.levelTags).forEach(tag_group=>tag_group.activated = true)
        Object.values(data.levelTags).forEach(tag_group=> {
            if (tag_group.siblings && tag_group.siblings.length > 0 && tag_group.activated ) {
            tag_group.siblings.forEach(sibling=>data.levelTags[sibling].activated=false)
            }
        })
        if (Object.values(data.levelTags).length > 1) {
            data.levelTags['Primaire'].activated = false
        }
        }
        detail_level=
        <Popover id='popover-details-level' style={{maxWidth:'100%'}}>
        <Popover.Header as="h3">{t('Banner.ndd')}</Popover.Header>
        <Popover.Body style={{maxHeight:'600px',overflowY:'auto',  marginLeft: '5px', width: '350px' }}>

            <>{(Object.entries(data.levelTags).length > 0) ? (<>
            {addAllDropDownNode(t,data,set_data,true)}</>
            ) : (<>
            <Form.Control placeholder="Pas de filtrage" style={{ opacity: opacity_advanced, color: '#6c757d' }} disabled /></>)}</>
        </Popover.Body>
        </Popover>
    } else {
        Object.values(data.levelTags).forEach(tag_group=>tag_group.activated = false)
        if ('Primaire' in data.levelTags) {
            data.levelTags['Primaire'].activated = true
        }
    }

    const {filter}=data.display_style
    const toolbar = toolbar_builder(
        t,data,set_data,mode_selection,user_scale,set_user_scale,filter,func_current_filter,
        detail_level,has_sankey_suite ? 'toto' :'',first_selected_node,set_first_selected_node,size_of_draw_zone,
        ((master_data && master_data.view.length > 0) || window.SankeyToolsStatic) ? SankeyViews.setDiagram(set_master_data,set_view) : setDiagram,
        set_show_modal_welcome,set_never_see_again,suite_convert_data,maximum_flux,set_maximum_flux,minimum_flux,set_minimum_flux
    )
    if (has_sankey_suite) {
        const {units_names} = data
        let units = undefined
        if (units_names  && units_names.length > 0 && units_names[0].length > 0) {
            units = [units_names[0][0], 'Naturelles']
            toolbar['unité']=additional_selector(data,set_data,units)
        }
    }
    Object.keys(toolbar).forEach(k=>{
        sankey_menus[k]=toolbar[k]
    })

    if(!window.SankeyToolsStatic || (window.SankeyToolsStatic && data.view.length!==0)){
        // toolbar.splice(0,0,SankeyViews.SankeyPlusBannerView(data,set_data,view,set_view,multi_selected_nodes,multi_selected_links,multi_selected_label,master_data,set_master_data,t,has_open_sankey_plus,set_view_not_saved))
        sankey_menus['view']=SankeyViews.SankeyPlusBannerView(data,set_data,view,set_view,multi_selected_nodes,multi_selected_links,multi_selected_label,master_data,set_master_data,t,has_open_sankey_plus,set_view_not_saved)
    }

    // if(!window.SankeyToolsStatic){
    const formatKeyHandler=(e:KeyboardEvent)=>{
        keyHandler(e,data,multi_selected_nodes,multi_selected_links,set_data,accordion_ref,button_ref,mode_selection,closeAllMenu
            )
        SankeyViews.keyHandler(
            e,
            view==='none',
            master_data,
            set_master_data,
            data,
            set_data,
            view,
            set_view,
            multi_selected_label,
            set_show_toast_new_view,
            set_show_toast_update_view,
            has_open_sankey_plus,
            set_view_not_saved,
        )
    }
    document.onkeydown = formatKeyHandler

    const navigate=useNavigate()
    const returnToApp=()=>{
      navigate('/')
      set_data({...data})
    }
    const additional_nav_item=[]

    const login_element=!window.SankeyToolsStatic ?<Nav>
        <Col>
          <Alert.Link onClick={()=> (token)?navigate('/dashboard'):navigate('/login')}  style={{display:'contents'}}>{(token)?name_user:t('connect')}</Alert.Link> {!token?<>/<Alert.Link onClick={()=> navigate('/license_register')}  style={{display:'contents'}}> {t('UserPages.to_reg')}</Alert.Link></>:<></>}
          <Button style={{'marginRight':'10px','marginLeft':'10px','width':'35px','height':'35px','backgroundColor':(!token)?'#ff7851':'#78c2ad','borderColor':(!token)?'#ff7851':'#78c2ad'}} onClick={()=> (token)?navigate('/dashboard'):navigate('/login')}><FaUser/></Button>
          {token?<Button style={{'marginRight':'15px','width':'35px','height':'35px'}}variant='danger' onClick={()=>loginOut(unsetTokens,returnToApp)}><FaPowerOff/></Button>:<></>}
        </Col>
      </Nav>:<></>
      additional_nav_item.push(login_element)



    // MENU DRAGGABLE NODE ATTR
    const menu_node_attr=menu_configuration_nodes_attributes
    const dragNodeAttr=show_menu_node_apparence?menu_draggable(menu_node_attr,pointer_pos,t('Menu.Noeuds')+' '+t('Noeud.apparence.apparence'),set_show_menu_node_apparence):<></>

    // MENU DRAGGABLE NODE LABEL
    const menu_node_label = SankeyMenuConfigurationNodesLabel(t,data,set_data,multi_selected_nodes,false,'default',true)
    const dragNodeLabel=show_menu_node_label?menu_draggable(menu_node_label,pointer_pos,t('Menu.Noeuds')+' '+t('Noeud.labels.labels'),set_show_menu_node_label):<></>

    // MENU DRAGGABLE NODE IO
    if(show_menu_node_io && multi_selected_nodes.current.length!==1){
        set_show_menu_node_io(false)
    }
    const menu_node_io=multi_selected_nodes.current.length===1?SankeyMenuConfigurationNodesIO(t,data,set_data,multi_selected_nodes,link_io,set_link_io,link_pos,set_link_pos,tab_colored,set_tab_colored,SuiteGetLinkValue,true):<></>
    const dragNodeIO=show_menu_node_io?menu_draggable(menu_node_io,pointer_pos,t('Menu.Noeuds')+' '+t('Noeud.PF.PFM'),set_show_menu_node_io):<></>

    // MENU DRAGGABLE NODE ICON
    const additional_context_node=[]
    if(has_open_sankey_plus){
        additional_context_node.push(context_node_icon(contextualised_node,set_show_menu_node_icon,set_contextualised_node,t))
    }
    const menu_node_icon = SankeyPlusNodeIcon(t,data,set_data,multi_selected_nodes,radio_selected,has_open_sankey_plus,true)
    const dragNodeIcon=show_menu_node_icon?menu_draggable(menu_node_icon,pointer_pos,t('Menu.Noeuds')+' '+t('Noeud.icon.icon'),set_show_menu_node_icon):<></>





    const context_n=context_menu_node(contextualised_node,set_contextualised_node,data,set_data,multi_selected_nodes,multi_selected_links,t,
        set_show_menu_node_apparence,set_show_menu_node_label,set_show_menu_node_io,
        set_agregation_node,set_is_agregation,set_show_agregation,
        set_display_link_opacity,
        pointer_pos,additional_context_node)


    // MENU DRAGGABLE LINK DATA
    const menu_link_data=SankeyMenuConfigurationLinksData(data,tags_selected,set_tags_selected,multi_selected_links,set_data,t,additional_data_element,displayed_input_link_value,set_displayed_input_link_value,true)
    const dragLink_data=show_menu_link_data?menu_draggable(menu_link_data,pointer_pos,t('Menu.flux')+' '+t('Flux.data.données'),set_show_menu_link_data):<></>


    // MENU DRAGGABLE LINK APPEARENCE
    const menu_link_appearence=SankeyMenuConfigurationLinksAppearence(data,multi_selected_links,set_data,t,add_style_link_appearence_item,false,'default',display_link_opacity,set_display_link_opacity,true)
    const dragLink_appearence=show_menu_link_appearence?menu_draggable(menu_link_appearence,pointer_pos,t('Menu.flux')+' '+t('Flux.apparence.apparence'),set_show_menu_link_appearence):<></>

    // MENU DRAGGABLE LINK LABEL
    const menu_link_label=SankeyMenuConfigurationLinksLabel(data,multi_selected_links,set_data,t,false,'default',true)
    const dragLink_label=show_menu_link_label?menu_draggable(menu_link_label,pointer_pos,t('Menu.flux')+' '+t('Flux.label.label'),set_show_menu_link_label):<></>

    const context_l=context_menu_link(contextualised_link,set_contextualised_link,
        set_show_menu_link_data,set_show_menu_link_appearence,set_show_menu_link_label
        ,data,set_data,tags_selected,multi_selected_links,t,pointer_pos)



    // MENU DRAGGABLE LAYOUT
    const drag_menu_layout=show_menu_layout?menu_draggable(menu_configuration_layout,pointer_pos,t('Menu.MEP'),set_show_menu_layout):<></>

  const context_for_zdd=context_zdd(show_context_zdd,set_show_context_zdd,data,set_data,pointer_pos,node_hspace,set_node_hspace,node_vspace,set_node_vspace,t,set_show_menu_layout)

    return (<>
            <div className='div-Menu' style={{ 'backgroundColor' : 'WhiteSmoke'}} >
            {dragNodeAttr}
            {dragNodeLabel}
            {dragNodeIO}
            {dragNodeIcon}

            {dragLink_data}
            {dragLink_appearence}
            {dragLink_label}

            {drag_menu_layout}
            <>
            <Menu
                t={t}
                data={data}
                set_data={set_data}
                default_sankey_data={get_default_data}
                show_nav={show_nav}
                set_show_nav={set_show_nav}
                nav_item_active={nav_item_active}
                set_nav_item_active={set_nav_item_active}
                show_menu={true}
                callback={has_sankey_suite ? processTrade : ()=>null }
                path={path}
                launch={launch}
                url_prefix={ url_prefix }
                logo={!window.SankeyToolsStatic ? logo : window.sankey.logo as string}
                // logo={ logo }
                logo_terriflux={logo_terriflux}
                logo_width={!window.SankeyToolsStatic ? 100 : window.sankey.logo_width}
                app_name={'Version 1.0.0' }
                mode_selection={mode_selection}
                style_to_apply={style_to_apply}
                set_style_to_apply={set_style_to_apply}

                selected_node={selected_node}
                multi_selected_nodes={multi_selected_nodes}
                multi_selected_links={multi_selected_links}
                multi_selected_label={multi_selected_label}
                accordion_ref={accordion_ref}
                nodes_accordion_ref={nodes_accordion_ref}
                links_accordion_ref={links_accordion_ref}
                button_ref={button_ref}
                show_load={show_load}
                set_show_load={set_show_load}
                processing={processing}
                setProcessing={setProcessing}
                failure={failure}
                setFailure={setFailure}
                not_started={not_started}
                setNotStarted={setNotStarted}
                result={result}
                setResult={setResult}
                configurations_menus={configurations_menus}
                menus={sankey_menus}
                show_excel_dialog={show_excel_dialog}
                show_apply_layout={show_apply_layout}
                show_save_json={false}
                showPreference={showPreference}
                showStyleNode={showStyle}
                show_publish_dialog={show_publish_dialog}
                selected_style_node={selected_style_node}
                selected_style_link={selected_style_link}
                showStyleLink={showStyleLink}
                set_show_excel_dialog={set_show_excel_dialog}
                set_show_apply_layout={set_show_apply_layout}
                set_show_save_json={(b:boolean)=>{}}
                setShowPreference={setShowPreference}
                set_selected_style_link={set_selected_style_link}
                set_selected_style_node={set_selected_style_node}
                set_show_publish_dialog={set_show_publish_dialog}
                setShowStyleNode={setShowStyle}
                setShowStyleLink={setShowStyleLink}
                cardsTemplate={cardsTemplate}
                // set_welcome_text={set_welcome_text}
                show_modalTemplate={show_modalTemplate}
                set_show_modalTemplate={set_show_modalTemplate}
                external_modal={external_menu_modal}
                // menu_banner={menu_banner}
                min_width_and_height={size_of_draw_zone}
                set_user_scale={set_user_scale}
                reinitialization={reinitialization}
                externale_save_item={additional_save_item}
                formations_menu={formations_menu}
                set_show_modale_tuto={set_show_modale_tuto}
                show_modale_tuto={show_modale_tuto}
                show_modale_support={show_modale_support}
                set_show_modale_support={set_show_modale_support}
                additional_nav_item={additional_nav_item}
                set_contextualised_node={set_contextualised_node}
                set_contextualised_link={set_contextualised_link}
                set_show_context_zdd={set_show_context_zdd}
                updateLayout={SuiteUpdateLayout}
                convert_data={suite_convert_data}
                node_hspace={node_hspace}
                set_node_hspace={set_node_hspace}
                node_vspace={node_vspace}
                set_node_vspace={set_node_vspace}
            />
            {/* New way to save the data, it save master data if the displayed sankey is a view or data if it's the master data */}
            <SankeySuiteDialogSaveJSON
                data={((master_data && view!=='none')?master_data:data)}
                set_data={set_data}
                show_save_json={show_save_json}
                set_show_save_json={set_show_save_json}
                t={t}
            />
            {has_open_sankey_plus && show_toast_new_view? SankeyViews.view_toast : null}
            {has_open_sankey_plus && show_toast_update_view? SankeyViews.view_toast_update_view : null}
            {/* <Modal
                bsSize="large"
                show={welcome_text !== undefined && welcome_text !== ''}
                onHide={()=>{
                set_welcome_text('')
                }}
                style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
                }}>
                <Modal.Header closeButton>
                <Modal.Title>Lisez Moi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {welcome_text ? parse(welcome_text) : ''}
                <Button
                    onClick={()=>{
                    set_welcome_text('')
                    }}
                >J&apos;ai lu</Button>
                </Modal.Body>
            </Modal> */}
            { has_sankey_suite && show_split_trade_dialog ?  (
                <SplitVerticalModal
                data = {data}
                initial_trade_node_names = {(data as SuiteSankeyData).trade_sectors ? (data as SuiteSankeyData).trade_sectors : [] }
                set_show_split_trade = {set_show_split_trade_dialog} />
            ) :(<div/>)}
            {has_sankey_suite && show_reconciliation ? (
                <SupplyUseModelisationProd
                show_reconciliation={true}
                action_type={action_type}
                set_show_reconciliation={set_show_reconciliation}
                sankey_data={data}
                set_sankey_data={set_data}
                callback = {processTrade} />
            ) :(<div />)}
            </>
            </div>
            {context_n}
            {context_l}
            {context_for_zdd}

        </>
    )

}
export default SankeySuiteMenu
